<div class="modal-body">
  <div class="alert alert-danger" *ngIf="error">
    <strong>Oh Noez!</strong>Une erreur est survenue!
    <button type="button" class="close" (click)="error=false">
      <span>&times;</span>
    </button>
  </div>

  <div class="form-group">
    <label>ISBN</label>
    <input type="text" class="form-control" [class.is-invalid]="result != undefined && result.isbnAlreadyExists || invalidIsbn" [(ngModel)]="newReferenceRequest.isbn">
    <div class="invalid-feedback" *ngIf="result != undefined || invalidIsbn">
      <ng-container *ngIf="result != undefined && result.isbnAlreadyExists">
        L'ISBN existe déjà!
      </ng-container>
      <ng-container *ngIf="invalidIsbn">
        ISBN invalide
      </ng-container>
    </div>
  </div>

  <div class="form-group">
    <label>Titre</label>
    <input type="text" class="form-control" [class.is-invalid]="invalidTitle" [(ngModel)]="newReferenceRequest.title">
    <div class="invalid-feedback" *ngIf="invalidTitle">
      Titre invalide
    </div>
  </div>

  <div class="form-group">
    <label>Prix</label>
    <input type="number" min="0" max="9999" step="0.01" class="form-control" [class.is-invalid]="invalidPrice" [(ngModel)]="newReferenceRequest.price">
    <div class="invalid-feedback" *ngIf="invalidPrice">
      Prix invalide
    </div>
  </div>

  <div class="form-group">
    <label>Fournisseur</label><br/>
    <supplier-picker [onSupplierSelected]="onSupplierSelected" [class.is-invalid]="invalidSupplier" ></supplier-picker>
    <div class="invalid-feedback" *ngIf="invalidPrice">
      Fournisseur invalide
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Annuler</button>
  <button type="button" class="btn btn-primary" [attr.disabled]="loading ? 'disabled' : null" (click)="saveReference()">
    <ng-container *ngIf="loading">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Chargement...
    </ng-container>
    <ng-container *ngIf="!loading">
      Créer la référence
    </ng-container>
  </button>
</div> 